<template>
  <div v-if="productList.length" class="product-list">
<!--    <div v-for="(item, index) in productList.slice(0, limit)" :key="index" class="product-item">
      &lt;!&ndash;  @click="commodityClick(item)" &ndash;&gt;
      &lt;!&ndash; <div class="image"></div> &ndash;&gt;
&lt;!&ndash;      <img class="image" :src="item.cover_url" alt="" srcset=""  />&ndash;&gt;
      <van-image class="image" :src="item.cover_url" fit="cover" alt="" srcset="" :width="108" :height="108" @click="commodityClick(item)">

      </van-image>

      <div class="bottom-container reading explain_div hx-flex-a-c" v-if="item.status === 'reading'">
        <div class="explain_left hx-flex-a-c">
          <div class="explain_round">
          </div>
          <div class="explain_text">讲解中</div>
        </div>
        <div class="explain_right voice-playing hx-flex-c-c hx-flex-j-e">
          <div class="play play1"></div>
          <div class="play play2"></div>
          <div class="play play3"></div>
          <div class="play play4"></div>
          <div class="play play5"></div>
        </div>
      </div>

      <div class="product_name">{{item.name}}</div>

      <div class="bottom-container hx-flex-c-c hx-flex-j-b">

        <div class="price_new" @click="link(item, index)"> &lt;!&ndash; 文本省略 快捷命令hx-text-ellipsis&ndash;&gt;
          ￥{{ decoratedValue(item.price) }}
        </div>
&lt;!&ndash;        <div class="price-bg"></div>&ndash;&gt;
      </div>
    </div>-->

<!--    <div
      v-if="productList.length > limit"
      class="more"
      @click="showMore = true"
    >
      更多<van-icon name="arrow-down" />
    </div>-->
    <!-- <div v-if="productListLoading" class="product-item hx-flex-c-c">
      <van-loading />
    </div> -->

    <!--展品第一个-->
    <!--<div class="product-item">
      &lt;!&ndash;  @click="commodityClick(item)" &ndash;&gt;
      &lt;!&ndash; <div class="image"></div> &ndash;&gt;
      &lt;!&ndash;      <img class="image" :src="item.cover_url" alt="" srcset=""  />&ndash;&gt;
      <van-image class="image" :src="currProduct.cover_url" fit="cover" alt="" srcset="" :width="108" :height="108" @click="commodityClick(currProduct)"/>

      <div class="bottom-container reading explain_div hx-flex-a-c" v-if="currProduct.status === 'reading'">
        <div class="explain_left hx-flex-a-c">
          <div class="explain_round">
          </div>
          <div class="explain_text">讲解中</div>
        </div>
        <div class="explain_right voice-playing hx-flex-c-c hx-flex-j-e">
          <div class="play play1"></div>
          <div class="play play2"></div>
          <div class="play play3"></div>
          <div class="play play4"></div>
          <div class="play play5"></div>
        </div>
      </div>

      <div class="product_name">{{currProduct.name}}</div>

      <div class="bottom-container hx-flex-c-c hx-flex-j-b">
        <div class="price_new" @click="link(currProduct)"> &lt;!&ndash; 文本省略 快捷命令hx-text-ellipsis&ndash;&gt;
          ￥{{ decoratedValue(currProduct.price) }}
        </div>
        &lt;!&ndash;        <div class="price-bg"></div>&ndash;&gt;
      </div>

      <div v-if="productList.length > limit" class="more" @click="clickShoppingCar(true)">更多<van-icon name="arrow-down" /></div>
    </div>-->



    <!--展品第一个 改为 轮播 -->
    <div class="product-item">
      <van-swipe ref="myPdSwipe" class="one-line custom-swipe" @change="onPdSwipeChange"
                 :autoplay="currProduct.status === 'reading' ? 0 : 3000" :show-indicators="true" indicator-color="#1edf41" :loop="true">
        <van-swipe-item v-for="(media, index) in productList" :key="index"  style="position: relative;">
          <van-image class="image" :src="media.cover_url" fit="cover" alt="" srcset="" :width="108" :height="108" @click="commodityClick(media)"/>

          <div class="bottom-container reading explain_div hx-flex-a-c" v-if="media.status === 'reading'">
            <div class="explain_left hx-flex-a-c">
              <div class="explain_round">
              </div>
              <div class="explain_text">讲解中</div>
            </div>
            <div class="explain_right voice-playing hx-flex-c-c hx-flex-j-e">
              <div class="play play1"></div>
              <div class="play play2"></div>
              <div class="play play3"></div>
              <div class="play play4"></div>
              <div class="play play5"></div>
            </div>
          </div>

          <div class="product_name">{{media.name}}</div>

          <div class="bottom-container hx-flex-c-c hx-flex-j-b" style="height: 30px">
            <div class="price_new" @click="commodityClick(media)"> <!-- 文本省略 快捷命令hx-text-ellipsis-->
              ￥{{ decoratedValue(media.price) }}
            </div>
            <!--        <div class="price-bg"></div>-->
          </div>



        </van-swipe-item>
      </van-swipe>
<!--      productList.length > limit-->
      <div v-if="false" class="more" @click="clickShoppingCar(true)">更多<van-icon name="arrow-down" /></div>
    </div>

    <van-popup
      class="my-pop"
      v-model="showMore"
      closeable
      round
      position="bottom"
      :overlay="false"
      :get-container="'#show-more-product-list-popup'"
      safe-area-inset-bottom
      >
      <!-- get-container="body"   :get-container="'#show-more-product-list-popup'"  safe-area-inset-bottom-->
      <!-- 开启顶部安全区适配 safe-area-inset-top 开启底部安全区适配 safe-area-inset-bottom-->

      <div class="popup-container">
        <div class="title">全部商品</div>
        <div class="popup-product-list">
          <div
            v-for="(item, index) in productList"
            :key="index"
            class="popup-product-item hx-card-radius hx-flex-c-c hx-flex-j-b"
          >
            <!-- @click="commodityClick(item)" -->
            <!-- <div class="image"></div> -->
            <img class="image" :src="item.cover_url" alt="" srcset="" @click="commodityClick(item)"/>
            <div class="center-container">
              <div class="name hx-text-ellipsis">{{ item.name }}</div>
              <div class="hx-text-ellipsis price">
                <span class="unit">￥{{ decoratedValue(item.price) }}</span>
              </div>
            </div>
            <div class="right-container hx-flex-c-c hx-flex-j-b flex_center">
              <div class="right-container-item green hx-btn-hover-f-b-08 flex_center" @click="commodityClick(item)">
                <div  class="hx-flex-c-c" v-if="item.status === 'reading'">
                  <div class="voice-playing hx-flex-c-c">
                    <div class="play play1"></div>
                    <div class="play play2"></div>
                    <div class="play play3"></div>
                    <div class="play play4"></div>
                    <div class="play play5"></div>
                  </div>
                </div>
                <span v-else> 详情 </span>
              </div>


              <div class="oringe-bg right-container-item hx-btn-hover-f-b-08" @click="orderPd(item)" v-if="false">下单</div>
            </div>

            <!-- <div class="click-area">
            <div class="top" @click="commodityClick(item)"></div>
            <div class="bottom" @click="link(item)"></div>
          </div> -->
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { getCommodityList } from "@/api/app";
import { SHOP_HOST, MEDIA_SHOW } from '@/api/constants'
export default {
  name: "ProductList",
  inject: ["sendMsgAnswerShowAndPlayEvent", "stopAllMedia", "clearTTSList","clearAudioList"],
  props: {
    sendMsgLoading: { type: Boolean, default: false },
    firstPlayed: { type: Boolean, default: false },
  },
  data() {
    return {
      showMore: false,
      limit: 1,
      productList: [],
      productListLoading: false,
      readingData: null,
      mediaDialog: true,
      currProduct: {},
      timeChange: 0
    };
  },
  computed: {
    // productListA() {
    //   return [...this.productList, ...this.productList, ...this.productList];
    // },
    decoratedValue(){
      return(value)=>{
        const decimalPlaces = (value.toString().split('.')[1] || '').length;
        return decimalPlaces > 2 ? value.toFixed(2) : value;
      }
    }
  },
  beforeDestroy() {},
  created() {
    Vue.prototype.$_getCommodityList = this._getCommodityList;
    // setTimeout(() => {
    //   this._getCommodityList();
    // }, 1000);
  },
  mounted() {
    /* const safeArea = document.getElementById('safeArea');
    const safeAreaBottom = getComputedStyle(safeArea).getPropertyValue('padding-bottom');
 */
    const winHeight = window.innerHeight
    const docHeight = document.documentElement.clientHeight
    const bottomHeight = winHeight - docHeight
    console.log('底部安全区域的像素值为:', bottomHeight);

  },
  methods: {
    clickShoppingCar(isShow){
      console.log('购物列表设置为：', isShow)

      if (!this.firstPlayed) {
        console.log('noah test enter clickShoppingCar')
        this.$myToast({
          message: "请先点击下方的 “你好” 进行唤醒",
        });
        return;
      }

      this.showMore = isShow
    },
    isWebURL(str) {
      // 定义网址的正则表达式
      const urlPattern = /^(https?:\/\/|www\.)\S+/i;
      // 使用正则表达式进行匹配
      return urlPattern.test(str);
    },
    isDomainURL(url){
      const specifiedDomain = 'h5.meuagi.com'

      // 正则表达式，用于匹配指定域名
      const regex = new RegExp(`^https?:\/\/${specifiedDomain}`, 'i')

      // 检查链接是否符合指定的域名
      if (regex.test(url)) {
        console.log('链接符合指定的域名规则')
        return true
      } else {
        console.log('链接不符合指定的域名规则')
        return false
      }
    },
    orderPd(item) {
      console.log('enter orderPd()')
      let url = item.url
      // 加入商城体系后 url需要预处理
      // 如果商品id不为空 则拼接商城id
      if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== ''){
        url = SHOP_HOST + item.mall_commodity_id
      }


      // 非我们的商城网址的，一律进行限制和提示
      /* if (!this.isDomainURL(url)){
        this.$myToast({
          type: "fail",
          message: "无效商品链接",
        })
        return
      } */

      // this.$myDialog({
      //   title: "网页跳转提示",
      //   message: url,
      //   showCancelButton: true,
      //   confirmButtonText: "确认跳转",
      //   closeOnClickOverlay: true,
      // })
      //   .then((result) => {
      //
      //
      //   })
      //   .catch((err) => {});

      if (window !== window.top){
        // 页面在一个 <iframe> 中加载
        // 打开一个新窗口
        console.log('页面在一个iframe中加载 打开一个新窗口')
        let newWindow = window.open('', '_blank')
        // 调整新窗口的链接
        newWindow.location.href = url
      } else {
        // 页面在顶层窗口中加载
        console.log('页面在顶层窗口中加载')


        let link = document.createElement("a");
        link.href = url;
        link.target = "_self" // _self _blank// 设置属性为'_self'，在当前标签页打开链接
        const originPhone = this.$store.state?.vuex_app_user_info?.phone || ''

        if (!this.$store.state.weiXinMark) {
          // 无用户的token 比如H5链接
          // 如果是H5 则打开新的窗口
          // 判断是否入驻 唤醒商城详情
          if(this.$store.state.vuex_app_user_info.mall_state === 3 && typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== '') {
            // 跳转小程序商品详情
            let paramsObj = {
              prodId: item.mall_commodity_id + '',
              originPhone: originPhone
            }
            const distId = this.$store.state?.vuex_app_user_info?.distributor_id || ''
            if (distId !== '') {
              paramsObj.distId = distId
            }
            this.$emit('jumpMiniProgram', 2, paramsObj)
          } else {
            console.log('没有商品id 则正常跳转其他网页')
            // this.validWebUrl(link, url)
          }
        } else {
          if (this.$store.state.miniProgramMark) {
            console.log('在微信小程序中打开的webview')
            // 如果是有商品id 则跳转小程序订单详情页面
            if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== ''){
              // 停止播报 @todo
              // 跳转到微信小程序A中的某个页面并携带参数
              wx.miniProgram.navigateTo({
                url: '/package-prod/pages/prod/prod?prodId=' + item.mall_commodity_id + '&originPhone=' + originPhone
              })
            } else {
              console.log('没有商品id 则正常跳转其他网页')
              // this.validWebUrl(link, url)
            }

          } else {
            console.log('在浏览器中打开的网页')
            // this.validWebUrl(link, url)
          }
        }
        // 测试的商城商品链接'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId=5'
        // this.$emit('onShopUrl', url)
      }
    },
    validWebUrl(link, url) {
      // 6月底版本 取消了url填写，一律不跳转
      if (typeof url === 'undefined' || url === '') {
        this.$myToast({
          type: "fail",
          message: "无商品链接",
        })
        return
      }
      if (!this.isWebURL(url)){
        this.$myToast({
          type: "fail",
          message: "无效商品链接",
        })
        return
      }
      link.target = "_blank"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    isNeedOpenMiniProgram(item) {
      // 在小程序中 不需要跳转小程序
      if (this.$store.state.miniProgramMark) {
        return false
      } else {
        if (this.$store.state.vuex_app_user_info.mall_state === 3 &&
          typeof item.mall_commodity_id !== 'undefined' &&
          item.mall_commodity_id !== '') {
          return true
        } else {
          return false
        }
      }

    },
    clearReading() {
      if (!this.readingData) {
        return;
      }
      this.readingData.status = "";
      this.readingData = null;
    },
    async commodityClick(item) {
      console.log('enter commodityClick')
      if (item.status === "reading") {
        this.$myToast({
          type: "fail",
          message: "正在讲解当前商品",
        });
        return;
      }
      if (this.sendMsgLoading) {
        this.$myToast({
          type: "fail",
          message: "已有任务正在进行",
        });
        return;
      }
      if (!this.firstPlayed) {
        /* console.log('noah test enter commodityClick')
        this.$myToast({
          message: "请先点击下方的 “你好” 进行唤醒",
        }); */
        this.$emit('onClickFirstProduct')
        return;
      }
      // // 一点击就停止
      // this.clearReading();
      // // 自己停一下媒体
      // this.stopAllMedia('commodityClick');

      if (!item?.comm_tip) {
        this.$myToast({
          type: "fail",
          message: "没有介绍内容",
        });
        return;
      }
      try {
        //! ! 一发送就清空，且不能放在stopAllMedia中清空
        this.clearTTSList();
        this.clearAudioList();
        this.$emit('onCommodityClick')
         const showMediaProdDialog = async () => {
           this.$emit('showProductDialog', item)
           this.stopAllMedia("commodityClick");

           this.currProduct = item
           await this.sendMsgAnswerShowAndPlayEvent(
             item?.comm_tip || "",
             // "红红火火恍，恍惚惚啊啊啊湿哒哒实，打实大师多撒四，大四大大萨达大萨达"
             "commodityClick"
           )
           this.clearReading();
           // item.status = "reading";
           this.$set(item, "status", "reading");
           this.readingData = item;
         }

        /* if (MEDIA_SHOW) {
          showMediaProdDialog()
          return
        } */
        const originPhone = this.$store.state?.vuex_app_user_info?.phone || ''
        if (!this.$store.state.weiXinMark) {
          // 无用户的token 比如H5链接
          // 如果是H5 则打开新的窗口
          // 判断是否入驻 唤醒商城详情
          if(this.$store.state.vuex_app_user_info.mall_state === 3 && typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== '') {
            // 跳转小程序商品详情
            let paramsObj = {
              prodId: item.mall_commodity_id + '',
              originPhone: originPhone
            }
            const distId = this.$store.state?.vuex_app_user_info?.distributor_id || ''
            if (distId !== '') {
              paramsObj.distId = distId
            }
            this.$emit('jumpMiniProgram', 2, paramsObj)
          } else {
            // 没有商品id 则正常跳转其他网页 打开模态框
            showMediaProdDialog()
          }
        } else {
          if (this.$store.state.miniProgramMark) {
            console.log('在微信小程序中打开的webview')
            // 如果是有商品id 则跳转小程序订单详情页面
            if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== ''){
              // 停止播报 @todo
              // 跳转到微信小程序A中的某个页面并携带参数
              wx.miniProgram.navigateTo({
                url: '/package-prod/pages/prod/prod?prodId=' + item.mall_commodity_id + '&originPhone=' + originPhone
              })
            } else {
              // 没有商品id 则正常跳转其他网页 打开模态框
              showMediaProdDialog()
            }

          } else {
            // 纯H5打开的
            // 没有商品id 则正常跳转其他网页 打开模态框
            if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== ''){
              // 纯H5 但是有user token，比如开发者自己调试模式
              // 跳转到微信小程序A中的某个页面并携带参数
              let paramsObj = {
                prodId: item.mall_commodity_id + '',
                originPhone: originPhone
              }
              const distId = this.$store.state?.vuex_app_user_info?.distributor_id || ''
              if (distId !== '') {
                paramsObj.distId = distId
              }
              this.$emit('jumpMiniProgram', 2, paramsObj)
            } else {
              // 没有商品id 则正常跳转其他网页 打开模态框
              showMediaProdDialog()
            }

          }
        }
      } catch (error) {
        console.log('打开模态框产品出错', error)
      }
    },
    async _getCommodityList() {
      try {
        this.productListLoading = true;
        const commodityListRes = await getCommodityList();
        const commodityList = commodityListRes?.data || [];
        this.productList = commodityList.filter(t => t.commodity_state !== 2)
        let shopIndex = commodityList.findIndex(t => t.mall_shop_id !== '')
        console.log('noah shop list shopIndex', shopIndex)
        if (shopIndex !== -1){
          let shopId = commodityList[shopIndex].mall_shop_id
          this.$store.commit('updateShopId', shopId + '')
        }

        // todo store 保存全局商品id
        // let findShopId =
        // this.currProduct = commodityList[0]
        this.productListLoading = false;
      } catch (error) {
        this.productListLoading = false;

        this.$myToast({
          type: "fail",
          message: error?.msg || "获取商品列表错误",
        });
      }
    },
    onPdSwipeChange (index) {
      this.currProduct = this.productList[index]
    }
  },
};
</script>

<style lang="less">
/*my-pop*/
#show-more-product-list-popup {
  .van-popup {
    background: var(--body-background-color) !important;
    z-index: 9 !important; // 如果是2009 会底部padding区域大于输入框遮挡住了
    position: absolute;
    max-height: 90vh;
    bottom: calc(63px + env(safe-area-inset-bottom) / 2); //  calc(64px + env(safe-area-inset-bottom))
    // padding-bottom: env(safe-area-inset-bottom); // 安全区域
  }
}
.image img {
  border-radius: 6px;
}
</style>
<style lang="less" scoped>
.popup-container {
  padding: 12px 12px 0 12px; /*var(--hx-card-padding);*/
  .title {
    font-size: 1.1em;
    text-align: center;
    line-height: 1.5;
    margin-bottom: 0.5em;
  }
}
.popup-product-list {
  max-height: 40vh;
  overflow-y: auto;
}
.popup-product-item {
  background: #383838;
  overflow: hidden;
  padding: var(--padding-xs);
  margin-bottom: var(--padding-xs);
  .image {
    position: relative;
    width: 3em;
    height: 3em;
    border-radius: calc(var(--hx-card-border-radius) / 3 * 2);
  }
  .center-container {
    padding: 0 var(--padding-sm);
    width: 30%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: 1;
  }
  .name {
    font-size: 0.8em;
    /*margin-bottom: 0.5em;*/
    padding: 0.4em 0;
  }
  .right-container {
    border-radius: calc(var(--hx-card-border-radius) / 3 * 2);
    background: #464847;
    overflow: hidden;
  }
  .right-container-item {
    font-size: 0.75em;
    width: 4em;

    padding: 0 var(--padding-base);
    text-align: center;
    line-height: 2.5;
    align-items: center;
    align-content: center;
    height: 30px;
  }
  .flex_center {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .green {
    color: #1edf41;
  }
  .oringe-bg {
    background: #fa6400;
  }
  .play {
    background: #1edf41;
  }
}
.product-list {
  padding: 4px;
  padding-bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  text-align: center;
  margin-left: 4px;
}
.product-item {
  /*width: 72px;
  min-height: 76px;*/
  width: 108px;
  min-height: 112px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 4px;
  font-size: 0;
  position: relative;
}
// .product-item::after {
//   // opacity: 0;
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(0, 0, 0, 0.3);
//   z-index: 1;
// }
.product-item:active {
  filter: brightness(0.85);
}
.product_name{
  float: left;
  width: 108px;
  max-height: 26px;
  margin: 7px 0;
  font-weight: 400;
  font-size: 10px;
  color: #FFFFFF;
  line-height: 13px;
  text-align: left;
  font-style: normal;
  padding: 0 7px;
  box-sizing: border-box;
  // 超出内容省略号
/*  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;*/
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bottom-container {
  // line-height: 16px;
  // height: 16px;
  // padding: 4px;
  // background: #fff;
  width: 100%;
  height: 25px;
}
.image {
  width: 100%;
  height: 52px;
  min-height: 52px;
  // background-repeat: no-repeat;
  background-position: center;
  background-size: cover;// cover
  // background: #fff;
  object-fit: cover;
  margin: 0;
  padding: 0;
  // margin-bottom: -1px;
  // background-image: url("https://img01.yzcdn.cn/vant/apple-3.jpg");
}

.click-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .top {
    height: 108px;
    // background: #de514d;
  }
  .bottom {
    height: 50%;
    // background: blue;
  }
}

.price_new {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 102px;
  height: 25px;
  padding: 2px 4px;
  background: #fe2c55;
  border-radius: 4px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
  font-style: normal;
}
.price {
  color: #fa6400;
  flex: 1;
  text-align: left;
  padding-left: 4px;
  // line-height: 24px;
  // height: 16px;
  justify-content: center;
  display: flex
}

.unit{
  width: 100%;
  word-break: break-word;
  min-height: 24px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.price-bg {
  width: 2em;
  height: 24px;

  background-color: #fa6400;
  color: #fff;
  background-size: 14px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("/src/assets/icon/gwc.png");
}

.more {
  font-size: 12px;
  padding: 8px 0 0 0;
  line-height: 1;
}

@play-h: 6px;

.reading {
  background: transparent;
  position: absolute;
  right: 6px;
  top: @play-h;
  margin-right: 2px;
}

.voice-playing {
  transform: scale(0.8);
}
.play {
  width: 2px;
  margin-left: 2px;
  height: @play-h;
  border-radius: 2px;
  background-color: #de514d;
}
.play1 {
  animation: playing 0.5s linear infinite alternate;
}
.play2 {
  animation: playing 0.5s 0.2s linear infinite alternate;
}
.play3 {
  animation: playing 0.5s 0.4s linear infinite alternate;
}
.play4 {
  animation: playing 0.5s 0.6s linear infinite alternate;
}
.play5 {
  animation: playing 0.5s 0.8s linear infinite alternate;
}
@keyframes playing {
  0% {
    transform: scaleY(0.5);
  }
  100% {
    transform: scaleY(2);
  }
}

.explain_div{
  width: 108px;
  position: absolute;
  left: 5px;
  top: 3px;
  display: flex;
  justify-content: space-around;
}

.explain_left{
  float: left;
  display: flex;
  width: 40px;
  height: 20px;
  padding: 0 5px;

  background: rgba(0,0,0,0.4);
  border-radius: 5px;

  backdrop-filter: blur(3px);

  font-weight: 400;
  font-size: 10px;
  color: #FFFFFF;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  align-items: center;

  .explain_round{
    float: left;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    margin-right: 4px;
  }
  .explain_text{
    float: left;
    width: 30px;
    height: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;
  }
}

.explain_right{
  float: left;
  flex: 1;
  height: 25px;
  padding-right: 5px;

}
</style>
